module.exports = require('./helpers/bundle-url').getBundleURL('37XjS') + "logo.c51670a8.svg";